import { render, staticRenderFns } from "./statusLoan.vue?vue&type=template&id=c1dbac52&scoped=true&"
import script from "./statusLoan.vue?vue&type=script&lang=js&"
export * from "./statusLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dbac52",
  null
  
)

export default component.exports